import { useSearchParams } from 'react-router-dom';
import { SESSION_PORTAIL } from '@semply/theme/Abonnement';
import { PaiementRetour } from '@semply/theme/PaiementRetour';
import { API_URL } from '../../lib/api';
import { PRODUITS, type Produit } from '../../lib/dossiers';
import { useSessionPortail } from '../dossiers/useSessionPortail';

/**
 * Retour du paiement Stripe (« Mes abonnements » du portail) : attend que le
 * webhook ait ouvert les droits, puis revient aux abonnements du produit.
 */
export function AbonnementRetourPage() {
  const { pret } = useSessionPortail();
  const [params] = useSearchParams();
  const brut = (params.get('produit') ?? '').toUpperCase() as Produit;
  const produit: Produit = PRODUITS.includes(brut) ? brut : 'APP';
  const retour = params.get('retour');
  const brutEspace = params.get('espace');
  const espace = brutEspace && /^[0-9a-f-]{36}$/i.test(brutEspace) ? brutEspace : null;
  const destination =
    `/abonnements?produit=${produit.toLowerCase()}` +
    `${espace ? `&espace=${encodeURIComponent(espace)}` : ''}` +
    `${retour ? `&retour=${encodeURIComponent(retour)}` : ''}`;

  if (!pret) return <p role="status">Chargement…</p>;
  return (
    <PaiementRetour
      apiUrl={`${API_URL}/espace`}
      getToken={SESSION_PORTAIL}
      product={produit}
      spaceId={espace}
      destination={destination}
      abonnementHref={destination}
    />
  );
}
